export const feedTypes = {
  uncompleted: "uncompleted",
  completed: "completed",
};
